export const SINGLE_USERPICKER_MUTATION_GROUP = 'singleSelectUserPickerFields' as const;
export const MULTI_USERPICKER_MUTATION_GROUP = 'multipleSelectUserPickerFields' as const;
